import React, { FunctionComponent, useRef } from "react";

import {
    ReportScrollableSection,
    ReportH1,
    ReportCard,
    IndexBar,
    ReportSectionNumber,
    ReportSectionHeader,
} from "../../../Common/";
import { RetailMatchKeyMetricsWrapper } from "../Styled/RetailMatchKeyMetricsStyles";
import {
    IRetailMatchJobResult,
    IRetailMatchOverview,
    IStoreScoreRecord,
} from "../../../../Models/IRetailMatch";
import { RetailMatchMetricLevel } from "../../../../Enums/RetailMatchMetricLevel";
import { RenderType } from "../../../../Enums/RenderType";
import { DigitalShareAppType } from "../../../../Enums/DigitalShareAppType";
import { DigitalShareItemType } from "../../../../Enums/DigitalShareItemType";
import { featureFlags } from "../../../../Common/CurrentFeatureFlags";
import {
    isOutputSelected,
    registerElement,
    registerRef,
} from "../../../Common/DigitalShare/DigitalShareGenerator";
import { RetailMatchKeyMetricsSharing } from "./RetailMatchKeyMetricsSharing";
import { IBrand } from "../../../../Models/IBrand";
import { brandOverviewRecord } from "../../../../Util/RetailMatch/RetailMatchUtil";

interface RetailMatchKeyMetricsProps {
  brand: IBrand;
  jobResult: IRetailMatchJobResult;
  locationAddress: string;
  benchmarkAddressOverride: IStoreScoreRecord;
  renderType: RenderType;
  app?: DigitalShareAppType;
  itemType?: DigitalShareItemType;
  shareText?: string;
}

export const RetailMatchKeyMetrics: FunctionComponent<RetailMatchKeyMetricsProps>
  = (props: RetailMatchKeyMetricsProps) => {
      const ref = useRef();

      const overviewRecord = brandOverviewRecord(
          props.brand.brandId,
          props.jobResult.chartData.overview
      );

      if (
          featureFlags.DigitalShare
      && props.renderType === RenderType.DIGITAL_SHARE
      && isOutputSelected(props.app, props.itemType)
      ) {
          registerRef(props.app.toString(), props.itemType.toString(), ref);
          registerElement(
              props.app.toString(),
              props.itemType.toString(),
              props.shareText,
              <RetailMatchKeyMetricsSharing
                  brandName={props.brand.brandName}
                  jobOverview={overviewRecord}
                  locationAddress={props.locationAddress}
                  jobResult={props.jobResult}
              />
          );
      }

      return (
          <ReportScrollableSection id="RMKeyMetrics">
              <ReportSectionHeader>
                  <ReportSectionNumber>01</ReportSectionNumber>
                  <ReportH1>Key Metrics</ReportH1>
              </ReportSectionHeader>
              <ReportCard>
                  <RetailMatchKeyMetricsWrapper>
                      <IndexBar
                          index={overviewRecord?.coreCustomerCountIndex}
                          title="Ideal Customer Count"
                          subTitle="How do counts of ideal households in the trade areas compare?"
                          scaleText={RetailMatchMetricLevel.Average}
                      />
                  </RetailMatchKeyMetricsWrapper>
                  <RetailMatchKeyMetricsWrapper>
                      <IndexBar
                          index={overviewRecord?.coreCustomerPerHouseholdIndex}
                          title="Ideal Customer Ratio"
                          subTitle="How does the ratio of ideal households to all households in the trade areas compare?"
                          scaleText={RetailMatchMetricLevel.Average}
                      />
                  </RetailMatchKeyMetricsWrapper>
                  <RetailMatchKeyMetricsWrapper>
                      <IndexBar
                          index={overviewRecord?.coreCustomerCorrelationIndex}
                          title="Ideal Customer Similarity"
                          subTitle="How similar is the mix of all households in the trade areas?"
                          scaleText={RetailMatchMetricLevel.Similarity}
                      />
                  </RetailMatchKeyMetricsWrapper>
              </ReportCard>
          </ReportScrollableSection>
      );
  };
